import { observer } from 'mobx-react';

import styles from './FileAssetList.module.scss';

import { FileAsset as StoreFileAsset } from '@store/models/FileAsset';
import { FileAsset } from './FileAsset';
import { store } from '@store';

interface Props {
    assets: StoreFileAsset[];
    onDeleteCLick: (fileName: string) => void;
}

export const FileAssetList = observer(({ assets, onDeleteCLick }: Props) => {
    const {
        authUser: { hasRootAccess },
    } = store;

    return (
        <div className={styles.root}>
            {assets
                .filter(file => (hasRootAccess ? true : !file.name.endsWith('.sgn')))
                .map(file => (
                    <div
                        className={styles.fileAsset}
                        key={file.path}
                    >
                        <FileAsset
                            asset={file}
                            onDeleteCLick={onDeleteCLick}
                        />
                    </div>
                ))}
        </div>
    );
});
